export const MAX_URL_LENGTH = 150;

export const validateHostname = (url) => {
  if (url.length === 0) {
    return true;
  }

  if (url.length > MAX_URL_LENGTH) {
    return false;
  }

  //Source: https://www.geeksforgeeks.org/how-to-validate-a-domain-name-using-regular-expression/
  const hostnameRegex = /^((?!-)[A-Za-z0-9-]{1,63}(?<!-)\.)+[A-Za-z]{2,}$/;
  return hostnameRegex.test(url);
};

export const validateUrl = (url) => {
  try {
    return Boolean(new URL(url));
  } catch {
    return false;
  }
};
